import { concat } from '@ember/helper';
import Component from '@glimmer/component';
import t from 'ember-intl/helpers/t';
import { type Signature as ProviderSig } from 'parog-web/components/forc/provider';
import type Patient from 'parog-web/models/patient';
import BaseAntecedentsFields from '../base-antecedents-fields';
interface Signature {
  Args: {
    form: ProviderSig['Blocks']['content'][0];
    patient: Patient;
  };
}

export default class MyComponent extends Component<Signature> {
  BaseAntecedentsFields = BaseAntecedentsFields;

  <template>
    <this.BaseAntecedentsFields
      @form={{@form}}
      @patient={{@patient}}
      as |familyMembers|
    >

      <h4 class='ui header'>Antécédents familiaux</h4>

      <div class='field'>
        <@form.ConditionalRadioGroup
          @conditionalValue={{true}}
          @propertyName='familyHistoryProstateCancer'
          as |ConditionalRadioGroup showConditionalBlock|
        >
          <div class='field'>
            <ConditionalRadioGroup.AlignedFieldsRadioGroup
              @title='Cancer de la prostate'
              as |Group|
            >
              <Group.FieldRadio @label='Oui' @value={{true}} />
              <Group.FieldRadio @label='Non' @value={{false}} />
            </ConditionalRadioGroup.AlignedFieldsRadioGroup>
          </div>

          {{#if showConditionalBlock}}
            <div class='field'>
              <@form.Dropdown
                @propertyName='familyHistoryProstateCancerMember'
                @multipleSelection={{true}}
                as |dropdown|
              >
                {{#each familyMembers as |familyMember|}}
                  <dropdown.Item
                    @key={{familyMember}}
                    @value={{t (concat 'family.' familyMember)}}
                  />
                {{/each}}
              </@form.Dropdown>
            </div>
          {{/if}}

        </@form.ConditionalRadioGroup>
      </div>
    </this.BaseAntecedentsFields>
  </template>
}
